import React from "react";
import LandingHeader from "@/components/landing/LandingHeader";
import LandingFooter from "@/components/landing/LandingFooter";
import { usePageMeta } from "@/hooks/usePageMeta";

import HomeHero from "@/components/landing/home/HomeHero";
import HomeProblem from "@/components/landing/home/sections/HomeProblem";
import HomePlatform from "@/components/landing/home/sections/HomePlatform";

import HomeSeeItInAction from "@/components/landing/home/sections/HomeSeeItInAction";
import HomeWhoItsFor from "@/components/landing/home/sections/HomeWhoItsFor";
import HomeLoadBoard from "@/components/landing/home/sections/HomeLoadBoard";
import HomeIntegrations from "@/components/landing/home/sections/HomeIntegrations";
import HomeFinalCTA from "@/components/landing/home/sections/HomeFinalCTA";

/* ------------------------------------------------------------------ */
/* Homepage — LR Direct focused. Hero + nav + footer are approved and  */
/* untouched; everything below the hero lives in ./home/sections.      */
/* ------------------------------------------------------------------ */

const LRDirectHomePage: React.FC = () => {
  usePageMeta({
    fullTitle: true,
    title: "LaneRunner — Freight Sourcing & Shipment Management",
    description:
      "Source capacity faster, compare every quote in one place, and manage each shipment from award to delivery.",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "LaneRunner",
        url: "https://lanerunner.com/",
        logo: "https://lanerunner.com/favicon.png",
        description:
          "LaneRunner is a freight sourcing and shipment management platform for shippers, brokers, and carriers.",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "LaneRunner",
        url: "https://lanerunner.com/",
        description:
          "Source capacity faster, compare every quote in one place, and manage each shipment from award to delivery.",
      },
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <LandingHeader variant="frosted" />

      {/* 1. HERO (approved — do not modify) */}
      <HomeHero />

      {/* 2. THE PROBLEM */}
      <HomeProblem />

      {/* 3. THE LANERUNNER PLATFORM */}
      <HomePlatform />


      {/* 5. SEE IT IN ACTION (only full-width dark section) */}
      <HomeSeeItInAction />

      {/* 6. WHO IT'S FOR */}
      <HomeWhoItsFor />

      {/* 7. LOAD BOARD */}
      <HomeLoadBoard />

      {/* 8. INTEGRATIONS */}
      <HomeIntegrations />

      {/* 9. FINAL CTA */}
      <HomeFinalCTA />

      <LandingFooter />
    </div>
  );
};

export default LRDirectHomePage;
